import { ENV } from '@/config/env'

type LogLevel = 'info' | 'warn' | 'error' | 'debug'

const LEVEL_STYLES: Record<LogLevel, string> = {
  info: 'color:#2970FF;font-weight:600',
  warn: 'color:#FF9C66;font-weight:600',
  error: 'color:#EF4444;font-weight:600',
  debug: 'color:#9CA3AF;font-weight:600',
}

function log(
  level: LogLevel,
  context: string,
  message: string,
  data?: unknown,
): void {
  // debug is verbose — only emit when VITE_DEBUG=true (mirrors __DEV__ guard on mobile)
  if (level === 'debug' && !ENV.DEBUG) return

  const prefix = `%c[${context}]`
  const style = LEVEL_STYLES[level]
  const method = level === 'debug' ? 'log' : level

  if (data !== undefined) {
    console[method](prefix, style, message, data)
  } else {
    console[method](prefix, style, message)
  }
}

export const logger = {
  info: (context: string, message: string, data?: unknown) =>
    log('info', context, message, data),
  warn: (context: string, message: string, data?: unknown) =>
    log('warn', context, message, data),
  error: (context: string, message: string, data?: unknown) =>
    log('error', context, message, data),
  debug: (context: string, message: string, data?: unknown) =>
    log('debug', context, message, data),
}
